import React, { createElement } from 'react';
import { Helmet } from 'react-helmet-async';
export function FontLoader() {
  return <Helmet data-id="element-34">
      {/* DNS prefetch and preconnect for faster resource loading */}
      <link rel="dns-prefetch" href="https://fonts.googleapis.com" data-id="element-35" />
      <link rel="dns-prefetch" href="https://fonts.gstatic.com" data-id="element-36" />
      <link rel="dns-prefetch" href="https://uploadthingy.s3.us-west-1.amazonaws.com" data-id="element-37" />
      <link rel="preconnect" href="https://fonts.googleapis.com" data-id="element-38" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" data-id="element-39" />
      <link rel="preconnect" href="https://uploadthingy.s3.us-west-1.amazonaws.com" data-id="element-40" />

      {/* Load Inter font with optimized display and async loading */}
      <link rel="preload" as="style" href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap&subset=latin" data-id="element-41" />
      <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap&subset=latin" rel="stylesheet" media="print" onLoad="this.media='all'" data-id="element-42" />

      {/* Preload critical hero image with high priority */}
      <link rel="preload" as="image" href="https://uploadthingy.s3.us-west-1.amazonaws.com/8CEXtjJmx3LKgwP68QaiJF/martin.webp" fetchPriority="high" data-id="element-43" />

      {/* Performance and SEO meta tags */}
      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=5" data-id="element-44" />
      <meta httpEquiv="x-ua-compatible" content="ie=edge" data-id="element-45" />

      {/* PWA and caching meta tags */}
      <meta name="theme-color" content="#2c0842" data-id="element-46" />
      <meta name="mobile-web-app-capable" content="yes" data-id="element-47" />
      <meta name="apple-mobile-web-app-capable" content="yes" data-id="element-48" />
      <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" data-id="element-49" />

      {/* Cache control headers */}
      <meta httpEquiv="Cache-Control" content="public, max-age=31536000, immutable" data-id="element-50" />

      {/* SEO improvements */}
      <meta name="description" content="The 9 AI tools Martin Randula actually uses every day. No fluff, just what works for building real products." data-id="element-51" />
      <meta name="author" content="Martin Randula" data-id="element-52" />
      <meta name="keywords" content="AI tools, ChatGPT, Firebase Studio, Perplexity, Lovable, Bolt.new, Replit, productivity" data-id="element-53" />

      {/* Open Graph */}
      <meta property="og:title" content="Martin's AI Kit - 9 AI Tools I Use Daily" data-id="element-54" />
      <meta property="og:description" content="The 9 AI tools I actually use every day. No fluff, just what works for me." data-id="element-55" />
      <meta property="og:type" content="website" data-id="element-56" />
      <meta property="og:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/8CEXtjJmx3LKgwP68QaiJF/martin.webp" data-id="element-57" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" data-id="element-58" />
      <meta name="twitter:title" content="Martin's AI Kit - 9 AI Tools I Use Daily" data-id="element-59" />
      <meta name="twitter:description" content="The 9 AI tools I actually use every day. No fluff, just what works for me." data-id="element-60" />
      <meta name="twitter:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/8CEXtjJmx3LKgwP68QaiJF/martin.webp" data-id="element-61" />

      {/* Inline critical CSS for above-the-fold content */}
      <style data-id="element-62">
        {`
          /* Critical CSS for initial render */
          body {
            margin: 0;
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
          }
          
          /* Prevent layout shift */
          #root {
            min-height: 100vh;
          }
        `}
      </style>

      {/* Smartsupp Live Chat script */}
      <script type="text/javascript" data-id="element-63">
        {`
          var _smartsupp = _smartsupp || {};
          _smartsupp.key = '3de266cb46b7da63c426a5911186e9f1d8d5cc8c';
          window.smartsupp||(function(d) {
            var s,c,o=smartsupp=function(){ o._.push(arguments)};o._=[];
            s=d.getElementsByTagName('script')[0];c=d.createElement('script');
            c.type='text/javascript';c.charset='utf-8';c.async=true;
            c.src='https://www.smartsuppchat.com/loader.js?';s.parentNode.insertBefore(c,s);
          })(document);
        `}
      </script>
    </Helmet>;
}